import { SECURE_WEBSITE_PROTOCOLE_PREFIX } from '~/constants/http';

export default function (url: string): boolean {
  return url.startsWith(SECURE_WEBSITE_PROTOCOLE_PREFIX);
}
